import React from 'react';

interface StatusBarProps {
  label: string;
  count: number;
  total: number;
  color: string;
  points: number;
  onClick?: () => void;
}

const StatusBar: React.FC<StatusBarProps> = ({ label, count, total, color, points, onClick }) => {
  const percentage = total > 0 ? (count / total) * 100 : 0;

  // Check if this is a risk status that needs a warning icon
  const isRiskStatus = label.toLowerCase().includes('unallocated') ||
    label.toLowerCase().includes('delayed') ||
    label.toLowerCase().includes('blocked') ||
    label.toLowerCase().includes('not responsible');

  return (
    <div
      className={`flex flex-col w-full mb-2.5 ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}`}
      onClick={onClick}
    >
      <div className="flex justify-between items-center mb-1 text-[10px]">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full" style={{ backgroundColor: color }}></span>
          {isRiskStatus && (
            <svg className="w-3.5 h-3.5 text-red-600 dark:text-red-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          )}
          <span className="text-light-text-secondary dark:text-gray-300 font-medium">{label}</span>
        </div>
        <div className="flex items-center gap-3">
          <span className="font-bold text-light-text-primary dark:text-white">{count}</span>
        </div>
      </div>
      <div className="w-full bg-light-surfaceSecondary dark:bg-slate-700 rounded-full h-1.5 overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500 ease-out"
          style={{ width: `${percentage}%`, backgroundColor: color }}
        />
      </div>
    </div>
  );
};

export default StatusBar;